import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaEye, FaTimes } from "react-icons/fa";

const Transaction = () => {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [profitHistory, setProfitHistory] = useState([]);
const [showProfitHistory, setShowProfitHistory] = useState(false);
  

  useEffect(() => {
    fetchTrades();
  }, []);
  const fetchProfitHistory = async (
  masterTradeId
) => {

  try {

    const res = await axios.get(
      `https://api.statixtrading.in/api/user-trade-profit/${masterTradeId}`
    );

    if (res.data.success) {

      setProfitHistory(res.data.data);

      setShowProfitHistory(true);

    }

  } catch (error) {

    console.log(error);

  }

};

  const fetchTrades = async () => {
    try {
      const res = await axios.get(
        "https://api.statixtrading.in/api/master-trade"
      );

      if (res.data?.success) {
        setTrades(res.data.data);
      
      } else {
        setTrades([]);
      }
    } catch (error) {
      console.log("ERROR:", error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>User Transaction</h2>

      <div style={styles.card}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>SN</th>
              <th style={styles.th}>UserName</th>
              <th style={styles.th}>Index Name</th>
              <th style={styles.th}>Strike price</th>
              <th style={styles.th}>P/L Type</th>
              <th style={styles.th}>P/L Amount</th>
              <th style={styles.th}>Qty</th>
              <th style={styles.th}>Date</th>
              {/* <th style={styles.th}>Action</th> */}
            </tr>
          </thead>

          <tbody>
            {trades.length === 0 ? (
              <tr>
                <td
                  colSpan="8"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No Data Found
                </td>
              </tr>
            ) : (
              trades.map((item,index) => (
              
                <tr key={item.id}>
                  <td style={styles.td}>{trades.length - index}</td>

                    <td style={styles.td}>
                    {item.account_holder_name}
                  </td>

                  <td style={styles.td}>
                    {item.index_name}
                  </td>
{/* 
                  <td style={styles.td}>
                      ₹ {item.amount}
                  </td> */}
                  <td style={styles.td}>
  ₹ {Math.floor(item.amount)}
</td>

                  <td
                    style={{
                      ...styles.td,
                      color:
                        item.pl_type === "Profit"
                          ? "green"
                          : item.pl_type === "Loss"
                          ? "red"
                          : "#333",
                      fontWeight: "bold",
                    }}
                  >
                    {item.pl_type === "Profit"
                      ? "Profit"
                      : item.pl_type === "Loss"
                      ? "Loss"
                      : item.pl_type}
                  </td>

                  <td style={styles.td}>
                    {item.pl_type === "Profit" ? '+' : '-'}
                    {item.pl_amount}
                  </td>

                  <td style={styles.td}>
                    {item.qty}
                  </td>

                  <td style={styles.td}>
                    {item.date
                      ? new Date(item.date).toLocaleString()
                      : "-"}
                  </td>

                  {/* <td style={styles.td}>
                    {item.trade_status == 'Closed' && (
                      <>

                    <button
  style={styles.updateBtn}
  onClick={() => fetchProfitHistory(item.id)}
>
  <FaEye />
</button>
</>)}                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    {showProfitHistory && (

  <div style={styles.modalOverlay}>

    <div
      style={{
        ...styles.modal,
        width: "95%",
        maxWidth: "650px",
      }}
    >

      <div
        className="d-flex justify-content-between"
      >
        <h3>Trade History</h3>

        <button
          style={styles.closeIconBtn}
          onClick={() =>
            setShowProfitHistory(false)
          }
        >
          ✕
        </button>
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >

        <thead>

          <tr>

            <th style={{ padding: "10px" }}>
             SN
            </th>

            <th style={{ padding: "10px" }}>
              Type
            </th>

            <th style={{ padding: "10px" }}>
              Amount
            </th>

            <th style={{ padding: "10px" }}>
              Trade
            </th>

            <th style={{ padding: "10px" }}>
              Qty
            </th>

          </tr>

        </thead>

        <tbody>

          {profitHistory.length > 0 ? (

            profitHistory.map((item,index) => (

              <tr key={item.id}>

                <td style={{ padding: "10px" }}>
                  {index+1}
                </td>

                <td
                  style={{
                    padding: "10px",
                    color:
                      item.pl_type === "Profit"
                        ? "green"
                        : "red"
                  }}
                >
                  {item.pl_type}
                </td>

                <td style={{ padding: "10px" }}>
                  ₹ {item.pl_amount}
                </td>

                <td style={{ padding: "10px" }}>
                  {item.trade_type}
                </td>

                <td style={{ padding: "10px" }}>
                  {item.qty}
                </td>

              </tr>

            ))

          ) : (

            <tr>

              <td
                colSpan="5"
                style={{
                  textAlign: "center",
                  padding: "20px"
                }}
              >
                No Data Found
              </td>

            </tr>

          )}

        </tbody>

      </table>

    </div>

  </div>

)}

   
    </div>
    
  );
};

const styles = {
  container: {
    padding: "20px",
    background: "#f4f6f9",
    minHeight: "100vh",
  },

heading: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  marginBottom: "20px",
  color: "#1e293b",
  fontWeight: "700",
  fontSize: "30px",
},

  card: {
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "900px",
  },

  th: {
    background: "#a8aeb6",
    color: "#fff",
    padding: "10px",
    textAlign: "center",
  },

  td: {
    padding: "10px",
    textAlign: "center",
    borderBottom: "1px solid #eee",
  },

  updateBtn: {
    padding: "8px 12px",
    marginRight: "5px",
    color: "#333",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },

  closeBtn: {
    padding: "8px 12px",
    color: "#f44336",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },

  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  modal: {
    background: "#fff",
    padding: "25px",
    borderRadius: "10px",
    width: "400px",
  },

  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },

  modalBtnBox: {
    display: "flex",
    justifyContent: "space-between",
  },

  // saveBtn: {
  //   padding: "10px 20px",
  //   background: "#4CAF50",
  //   color: "#fff",
  //   border: "none",
  //   borderRadius: "5px",
  //   cursor: "pointer",
  // },
  saveBtn: {
  padding: "10px 20px",
  background: "#3c3d3c",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  display: "block",
  margin: "0 auto",
},


  modalHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
},

closeIconBtn: {
  background: "transparent",
  border: "none",
  fontSize: "20px",
  cursor: "pointer",
  color: "#555",
},
};

export default Transaction;